import React from 'react';
import { CreditCard, Sparkles } from 'lucide-react';
import UnifiedHeader from '@/components/layout/UnifiedHeader';
import { useCurrentNavItem } from '@/hooks/useCurrentNavItem';

interface SubscriptionsHeaderProps {
  title?: string;
  description?: string;
}

export const SubscriptionsHeader = ({ 
  title = "Planos Premium", 
  description = "Escolha a ideal para você" 
}: SubscriptionsHeaderProps) => {
  const currentNavItem = useCurrentNavItem();
  const Icon = currentNavItem?.icon || CreditCard;
  
  const rightContent = (
    <div className="flex items-center gap-1">
      <Sparkles className="h-4 w-4 text-luxury-gold" />
      <span className="text-luxury-gold text-xs font-medium hidden sm:inline">Premium</span>
    </div>
  );

  return (
    <UnifiedHeader
      title={currentNavItem?.label || title}
      subtitle={currentNavItem?.description || description}
      icon={Icon}
      iconColor="text-white"
      iconBgColor="bg-luxury-pinkBright border-luxury-pinkBright"
      rightContent={rightContent}
    />
  );
};
